import {
  GET_MENU_ITEMS,
  SET_SELECTED_FOLDER,
  SET_SELECTED_TABLE,
  SET_SELECTED_MODULE,
  GET_MODULE_INFO,
  SET_SELECTED_MODULE_NAME,
  SET_LOADING_STATE,
  SET_MODULE_CONFIGURATION,
  SET_TABLE_LIST,
  SET_FOLDERS_LIST_WITH_EXCEPTIONS,
  ADD_TAG_TO_TAGS_LIST,
  UPDATE_TAGS_LIST,
  REMOVE_TAG_FROM_TAGS_LIST,
} from './mutation-types';

export default {
  [GET_MENU_ITEMS](state, payload) {
    state.menuItems = payload;
  },
  [SET_SELECTED_TABLE](state, payload) {
    state.selectedTable = payload ? payload.entityGuid : payload;
    state.selectedFolder = payload ? payload.folderGuid : payload;
    state.selectedFolderName = payload ? payload.folderName : payload;
    state.selectedModule = payload ? payload.moduleGuid : payload;
  },
  [SET_SELECTED_FOLDER](state, payload) {

    state.selectedFolder = payload ? payload.folderGuid : payload;
    state.selectedFolderName = payload ? payload.label : payload;
  },
  [SET_SELECTED_MODULE](state, payload) {
    state.selectedModule = payload;
  },
  [GET_MODULE_INFO](state, payload) {
    state.moduleInfo = payload;
  },
  [SET_SELECTED_MODULE_NAME](state, payload) {
    state.selectedModuleName = payload;
  },
  [SET_LOADING_STATE](state, payload) {
    state.isLoading = payload;
  },
  [SET_MODULE_CONFIGURATION](state, payload) {
    state.moduleConfiguration = payload;
  },
  [SET_TABLE_LIST](state, payload) {
    const {modules, tables, folders} = payload;
    state.modulesList = modules;
    state.foldersList = folders;
    state.tablesList = tables;
  },
  [SET_FOLDERS_LIST_WITH_EXCEPTIONS](state, payload) {
    state.foldersListWithExceptions = {...state.foldersListWithExceptions, ...payload};
  },
  [ADD_TAG_TO_TAGS_LIST](state, payload) {
    state.tablesList[payload.tableId].tags.push(payload.data);
  },
  [UPDATE_TAGS_LIST](state, payload) {
    state.tablesList[payload.tableId].tags = state.tablesList[payload.tableId].tags.map(el => (
      el.tagGuid === payload.data.tagGuid ? payload.data : el
    ));
  },
  [REMOVE_TAG_FROM_TAGS_LIST](state, payload) {
    state.tablesList[payload.tableId].tags = state.tablesList[payload.tableId].tags.filter(el => (
      el.tagGuid !== payload.tagId
    ));
  },
};
